import React, { useEffect, useState } from "react";
import "./Profile.css";
import Header from "../../Layout/Header";
import Header2 from "../../Layout/Header2";
import checkIcon from "../../Images/circle-check-solid.svg";
import { toast } from "react-toastify";
import AuthService from "../../Services/AuthService";
import { data, useNavigate } from "react-router-dom";
import HomeService from "../../Services/HomeService";
import UserProfile from "./UserProfile";
import { useDispatch } from "react-redux";
import { getUser } from "../../Stores/Slices/AuthSlice";
const Profile = () => {
  const [isRightPanelActive, setIsRightPanelActive] = useState(false);
  const [email, setEmail] = useState("");
  const [loginEmail, setLoginEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loginProfile, setLoginProfile] = useState(false);
  const [token, setToken] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [getCitiesForUser, setGetCitiesForUser] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [IsLoginPasswordVisible, setIsLoginPasswordVisible] = useState(false);
  const [isSignUpPasswordVisible, setIsSignUpPasswordVisible] = useState(false);
  const [isSignUpConfirmPasswordVisible, setIsSignUpConfirmPasswordVisible] =
    useState(false);
  const dispatch = useDispatch();

  const [registerDetails, setRegisterDetails] = useState({
    email: "",
    otp: "",
    fullName: "",
    password: "",
    city: "",
    companyName: "",
    address: "",
    mobileNo: "",
    workExpYear: "",
  });

  // const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // const passWord = password.length >= 4 && password.length <= 15;

  const navigate = useNavigate();

  const handleSignUpClick = () => {
    setIsRightPanelActive(true);
  };

  const handleSignInClick = async () => {
    setIsRightPanelActive(false);
  };

  const getLoginProfile = async () => {
    const res = await HomeService.getLoginProfile();
    console.log("login profile response", res);

    setLoginProfile(res.status);
    // console.log("login profile", loginProfile);
  };

  const handleLogIn = async (e) => {
    e.preventDefault();
    // console.log("login clicked");

    const isValid = loginEmail.trim() !== "" && loginPassword.trim() !== "";
    if (isValid) {
      if (!loginEmail.match(mailFormat)) {
        toast.error("Invalid Email");
      } else {
        const data = {
          email: loginEmail,
          password: loginPassword,
        };

        try {
          const res = await AuthService.getLogin(data);

          // console.log("this data is during login", res);

          if (res?.status) {
            toast.success("Logged in successfully!");
            localStorage.setItem("token", res?.data?.token);
            localStorage.setItem("loggedInUserId", res?.data?.userDetails?._id);
            // Refresh the complete website after login
            setTimeout(() => {
              window.location.href = "/";
            }, 500);

            // dispatch(getUser());

            // localStorage.setItem("userName", res?.data?.userDetails?.fullName);
            // localStorage.setItem("address", res?.data?.userDetails?.address);
            // localStorage.setItem(
            //   "companyName",
            //   res?.data?.userDetails?.companyName,
            // );
            // localStorage.setItem(
            //   "businessField",
            //   res?.data?.userDetails?.businessField,
            // );
            // localStorage.setItem(
            //   "majorLocality",
            //   res?.data?.userDetails?.majorLocality,
            // );
            // localStorage.setItem(
            //   "experience",
            //   res?.data?.userDetails?.workExpYear,
            // );
            // localStorage.setItem(
            //   "phoneNumber",
            //   res?.data?.userDetails?.mobileNo,
            // );
            // navigate("/");
            // console.log("6df5g6f4dg646fd", res)
            // getLoginProfile()
          } else {
            toast.error(res?.message);
          }
        } catch (error) {
          console.log(error);
          toast.error(error?.message);
        }
      }
    } else {
      toast.error("Please fill all the Inputs..");
    }
  };

  const handleVerifyEmail = async () => {
    const isValid = email.trim() !== "";

    if (isValid) {
      if (!email.match(mailFormat)) {
        toast.error("Invalid Email");
      } else {
        const data = { email: email };
        const res = await HomeService.verifyEmail(data);

        if (res && res.status === false) {
          toast.error(res?.message);
          setIsRightPanelActive(false);
        }

        if (res && res.status) {
          toast.success("OTP Has been sent!");
          setRegisterDetails((prevDetails) => ({
            ...prevDetails,
            email: email,
          }));

          setOtp(res.data);
          setIsEmailVerified(true); // ✅ Set to true when email is verified
        }
      }
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    // console.log("handle signup is clicked");

    const {
      email,
      otp,
      fullName,
      password,
      city,
      companyName,
      address,
      mobileNo,
      workExpYear,
    } = registerDetails;

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      // console.log("password do not match");

      return;
    }

    if (!otp) {
      toast.error("Please verify your email and enter OTP");
      return;
    }

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email.trim())) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (
      !email ||
      !otp ||
      !fullName ||
      !password ||
      !city ||
      !companyName ||
      !address ||
      !mobileNo
    ) {
      toast.error("Please fill all the fields ");
      return;
    }

    if (mobileNo?.toString()?.length !== 10) {
      toast?.error("Phone number must be in 10 digits");
      return;
    }
    // console.log("sjflsdfsl");
    console.log("data", registerDetails);

    try {
      // console.log("this data is send to register", registerDetails);

      const res = await AuthService.register(registerDetails);
      // console.log("this data is after register", res);

      if (res?.status) {
        toast.success("Registration successful!");
        setIsRightPanelActive(false);
        toast.success("Logged in successfully!");
        localStorage.setItem("token", res?.data?.token);
        localStorage.setItem("loggedInUserId", res?.data?.userDetails?._id);
        // dispatch(getUser());
        // localStorage.setItem("userName", res?.data?.userDetails?.fullName);
        // localStorage.setItem("address", res?.data?.userDetails?.address);
        // localStorage.setItem(
        //   "companyName",
        //   res?.data?.userDetails?.companyName,
        // );
        // localStorage.setItem(
        //   "businessField",
        //   res?.data?.userDetails?.businessField,
        // );
        // localStorage.setItem(
        //   "majorLocality",
        //   res?.data?.userDetails?.majorLocality,
        // );
        // localStorage.setItem("experience", res?.data?.userDetails?.workExpYear);
        // localStorage.setItem("phoneNumber", res?.data?.userDetails?.mobileNo);
        navigate("/");
      } else {
        toast.error(res?.message || "Registration failed.");
        // console.log("registration failed");
      }
    } catch (error) {
      toast.error("Error during registration.");
      console.log("error during registration");
    }
  };
  useEffect(() => {
    getLoginProfile();

    const token = localStorage.getItem("token");
    // console.log("token", token);

    if (token) {
      setToken(true);
    } else {
      setToken(false);
    }
  }, [token]);

  const fetchCitiesForUser = async () => {
    try {
      const res = await HomeService.getCitiesForUser();
      console.log("Get city list", res);
      setGetCitiesForUser(res.data);
    } catch (error) {
      console.error("error in fetching City Details", error);
      toast.error("Error Fetching City Details!");
    }
  };

  useEffect(() => {
    fetchCitiesForUser();
    window.scroll(0, 0);
  }, []);

  const handleChange = (e) => {
    setSelectedCity(e.target.value);
    //console.log("Selected City ID:", e.target.value);
    setRegisterDetails({
      ...registerDetails,
      city: e.target.value,
    });
  };

  return (
    <>
      <Header2 />
      <div className="form_wrapper856">
        {console.log("login profile and token", loginProfile, token)}
        {!loginProfile && !token ? (
          <div
            className={`container2  ${isRightPanelActive ? "right-panel-active" : ""
              }`}
            id="container"
          >
            {/* Sign Up Container */}
            <div className="form-container sign-up-container">
              <form className="form_class" action="#">
                <h1 className="create_account_para">Sign Up</h1>
                <p className="sign_up_para565">
                  Already have an account?{" "}
                  <span
                    className="span_sign_up"
                    style={{ cursor: "pointer" }}
                    onClick={handleSignInClick}
                  >
                    Sign In
                  </span>
                </p>

                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Name"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      fullName: e.target.value,
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="email"
                  placeholder="Enter Email Addresss"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    // setRegisterDetails({
                    //   ...registerDetails,
                    //   email: e.target.value,
                    // });
                  }}
                  value={email}
                />
                <div className="d-flex justify-content-end w-100">
                  <p
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      fontFamily: "Roboto",
                      cursor: "pointer",
                    }}
                    onClick={handleVerifyEmail}
                  >
                    Verify Email
                  </p>

                  {/* ✅ Show verified icon if email is successfully verified */}
                  {isEmailVerified && (
                    <img
                      src={checkIcon}
                      alt="Verified"
                      style={{
                        width: "16px",
                        height: "16px",
                        marginLeft: "8px",
                      }}
                    />
                  )}
                </div>
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Code Received on Email"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      otp: e.target.value,
                    })
                  }
                />
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Company Name"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      companyName: e.target.value,
                    })
                  }
                />
                {/* <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter City"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      city: e.target.value,
                    })
                  }
                /> */}

                <select
                  className="input_class5566"
                  value={selectedCity}
                  onChange={handleChange}
                >
                  <option value="">-----Select City-----</option>
                  {getCitiesForUser?.map((city, i) => {
                    return (
                      <option key={i} value={city._id}>
                        {city.name}
                      </option>
                    );
                  })}
                </select>

                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Address"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      address: e.target.value,
                    })
                  }
                />
                <input
                  value={registerDetails?.mobileNo}
                  className="input_class5566"
                  type="text"
                  placeholder="Enter Contact Number"
                  // onChange={(e) =>
                  //   setRegisterDetails({
                  //     ...registerDetails,
                  //     mobileNo: Number(e.target.value),
                  //   })
                  // }
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) {
                      setRegisterDetails((prev) => ({
                        ...prev,
                        mobileNo: Number(e.target.value),
                      }));
                    }
                  }}
                />
                <input
                  className="input_class5566"
                  type="text"
                  placeholder="Work Experience"
                  onChange={(e) =>
                    setRegisterDetails({
                      ...registerDetails,
                      workExpYear: Number(e.target.value),
                    })
                  }
                />
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    className="input_class5566"
                    type={isSignUpPasswordVisible ? "text" : "password"}
                    placeholder="Password"
                    onChange={(e) =>
                      setRegisterDetails({
                        ...registerDetails,
                        password: e.target.value,
                      })
                    }
                    style={{ paddingRight: "50px" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      height: "100%",
                    }}
                    onClick={() => {
                      setIsSignUpPasswordVisible(!isSignUpPasswordVisible);
                    }}
                  >
                    {isSignUpPasswordVisible ? (
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i class="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </div>
                </div>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    className="input_class5566"
                    type={isSignUpConfirmPasswordVisible ? "text" : "password"}
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{ paddingRight: "50px" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      height: "100%",
                    }}
                    onClick={() => {
                      setIsSignUpConfirmPasswordVisible(
                        !isSignUpConfirmPasswordVisible,
                      );
                    }}
                  >
                    {isSignUpConfirmPasswordVisible ? (
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i class="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </div>
                </div>
                <button
                  className="submit_btn6565"
                  type="submit"
                  onClick={handleSignUp}
                >
                  Sign Up
                </button>
              </form>
            </div>

            {/* Sign In Container */}
            <div className="form-container sign-in-container">
              <form className="form_class" action="#">
                {/* <h1 className="create_account_para">Log in</h1> */}
                {/* <p className="sign_up_para565">
                  Doesn't have an account yet ?{" "}
                  <span className="span_sign_up" onClick={handleSignUpClick}>
                    Sign Up
                  </span>
                </p> */}
                <div class="welcome_wrapper">
                  <h1 class="welcome_title">Welcome</h1>
                  <p class="welcome_subtitle">
                    Enter your details to access your property portfolio
                  </p>
                </div>

                <label className="lebel_pl">Email Adress</label>
                <input
                  className="input_class5566"
                  type="email"
                  placeholder="Email"
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                />
                <label className="lebel_pl">Password</label>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    className="input_class5566"
                    type={IsLoginPasswordVisible ? "text" : "password"}
                    placeholder="Password"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    style={{ paddingRight: "50px" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      height: "100%",
                    }}
                    onClick={() => {
                      setIsLoginPasswordVisible(!IsLoginPasswordVisible);
                    }}
                  >
                    {IsLoginPasswordVisible ? (
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i class="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </div>
                </div>
                <div class="remember_forgot_rm">
                  <label class="remember_label_rm">
                    <input type="checkbox" class="remember_checkbox_rm" />
                    <span class="remember_text_rm">Remember me</span>
                  </label>

                  <a href="#" class="forgot_password_rm">
                    Forgot password?
                  </a>
                </div>

                {/* <a className="social" href="#">
                  Forgot your password?
                </a> */}
                <button
                  className="submit_btn6565"
                  type="submit"
                  onClick={(e) => handleLogIn(e)}
                >
                  Sign In <i class="fa-solid fa-arrow-right"></i>
                </button>
                <div class="continue_wrapper">
                  {/* <p class="continue_text">OR CONTINUE WITH</p> */}
                  {/* <div class="or_wrapper">
                    <span class="or_text">OR CONTINUE WITH</span>
                  </div>

                  <div class="continue_buttons">
                    <button class="social_btn google_btn">
                      <img
                        src="https://www.svgrepo.com/show/475656/google-color.svg"
                        alt="google"
                      />
                      Google
                    </button>

                    <button class="social_btn facebook_btn">
                      <img
                        src="https://img.icons8.com/?size=96&id=118497&format=png"
                        alt=""
                      />
                      Facebook
                    </button>
                  </div> */}

                  <p class="signup_text">
                    Don't have an account?
                    <a href="#" class="signup_link" onClick={handleSignUpClick}>
                      Sign up
                    </a>
                  </p>
                </div>
              </form>
            </div>

            {/* Overlay Container */}
            <div className="overlay-container">
              <div className="overlay">
                <div className="overlay-panel overlay-left">
                  <h1
                    style={{
                      fontWeight: "700",
                      // color: "#003466",
                    }}
                    className="wel"
                  >
                    Welcome Back!
                  </h1>
                  <p
                    className="para565"
                    style={{
                      fontWeight: "700",
                    }}
                  >
                    To keep connected with us please login with your personal
                    info
                  </p>
                  <button
                    className="  submit_btn6565 ghost addi_sign_btn"
                    id="signIn"
                    style={{
                      cursor: "pointer",
                      background: "white",
                      color: "rgb(0, 52, 102)",
                    }}
                    onClick={handleSignInClick}
                  >
                    Sign In
                  </button>
                </div>
                <div className="overlay-panel overlay-right">
                  <h1
                    style={{
                      color: "rgb(0, 52, 102)",
                      fontWeight: "700",
                    }}
                  >
                    Hello, Friend!
                  </h1>
                  <p
                    className="para565"
                    style={{
                      color: "rgb(0, 52, 102)",
                      fontWeight: "700",
                    }}
                  >
                    Enter your personal details and start your journey with us
                  </p>
                  <button
                    className=" submit_btn6565 ghost addi_sign_btn"
                    style={{
                      border: "none",
                      // background: "rgb(0, 52, 102)",
                    }}
                    id="signUp"
                    onClick={handleSignUpClick}
                  >
                    Sign Up <i class="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <UserProfile />
        )}
        {/* Add UserProfile Component Below */}

        {/* <UserProfile /> */}
      </div>
    </>
  );
};

export default Profile;
